import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/arrow-right.css';
import stylesUndoRedo from '../../../../../stylesheet/css/header-builder/undo-redo.css';

const ArrowRight = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="13.6px" height="11.7px" viewBox="0 0 13.6 11.7" xmlSpace="preserve" fill="#ffffff">
    <g>
      <g>
        <path className={`st0 ${stylesUndoRedo.svgPath}`} d="M13.3,3.3L8.3,0.1C8-0.1,7.5,0.1,7.5,0.5v2.3C3.3,3,0,6.5,0,10.7c0,0.6,0.4,1,1,1s1-0.4,1-1 C2,7.6,4.4,5,7.5,4.8V7c0,0.4,0.4,0.6,0.8,0.4l5.1-3.2C13.6,4,13.6,3.5,13.3,3.3z"/>
      </g>
    </g>
  </svg>
);

export default ArrowRight;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/ArrowRight.js